function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M117.173 78.583h-12.167a1.75 1.75 0 0 0-1.75 1.75v31.98H24.744v-31.98a1.75 1.75 0 0 0-1.75-1.75H10.827a1.75 1.75 0 0 0-1.75 1.75v45.9a1.75 1.75 0 0 0 1.75 1.75h106.346a1.75 1.75 0 0 0 1.75-1.75v-45.9a1.75 1.75 0 0 0-1.75-1.75zm-1.75 45.9H12.577v-42.4h8.667v31.98a1.75 1.75 0 0 0 1.75 1.75h82.013a1.75 1.75 0 0 0 1.75-1.75v-31.98h8.667z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M62.763 90.018a1.771 1.771 0 0 0 2.475 0L97.764 57.49a1.771 1.771 0 0 0 0-2.475l-8.6-8.6a1.749 1.749 0 0 0-2.475 0L71.833 61.266V1.73a1.75 1.75 0 0 0-1.75-1.75H57.917a1.75 1.75 0 0 0-1.75 1.75v59.536L41.313 46.413a1.749 1.749 0 0 0-2.475 0l-8.6 8.6a1.771 1.771 0 0 0 0 2.475zM40.076 50.125l16.6 16.6a1.75 1.75 0 0 0 2.987-1.237V3.48h8.667v62.01a1.75 1.75 0 0 0 2.987 1.237l16.6-16.6 6.128 6.128L64 86.306 33.948 56.253z"
});

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    stroke: "currentColor",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d6c9f446.svg";
export { ForwardRef as ReactComponent };